import axios from "axios";
import { store } from "@/utils/store";
import ErrorInterceptor from "@/modules/errors/error-services/errors-interceptor";

//used for log call withno token
export const authax = axios.create({
  baseURL: window.__env.back_end.base_url,
});

authax.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    /* push alert with login failed and why */
    return Promise.reject(ErrorInterceptor.helper(error));
  }
);

export const auth =authax

//for backend
const httpax = axios.create({
  baseURL: window.__env.back_end.base_url,
});

httpax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
httpax.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    const errorMessage = ErrorInterceptor.helper(error);
    ErrorInterceptor.serverError(errorMessage)
    /**inser what to do in case of error */
    return Promise.reject(errorMessage);
  }
);
export const http = httpax;

// for once
const onceax = axios.create({
  baseURL: window.__env.back_end.once_url,
});

onceax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});

onceax.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    /**inser what to do in case of error */
    return Promise.reject(ErrorInterceptor.helper(error));
  }
);
export const once = onceax;

// for Geocoding API v4 — routed by the gateway:
// /ambr/google-maps/v4/geocode/** -> https://geocode.googleapis.com/v4/geocode/**
// Only the Basic token from local storage is sent. The Google API key is injected server-side by
// Traefik (google-maps-key middleware) and must never reach the browser: an X-Goog-Api-Key set
// here would be overwritten by the gateway anyway, and it would add a header to the CORS
// preflight for no reason.
const geocodingax = axios.create({
  baseURL: window.__env.back_end.google_url,
});

geocodingax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
geocodingax.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    const errorMessage = ErrorInterceptor.helper(error);
    ErrorInterceptor.serverError(errorMessage)
    /**inser what to do in case of error */
    return Promise.reject(errorMessage);
  }
);
export const geocoding = geocodingax;

// for casterapi -- OLD require evaluation and in case removal
const casterapiax = axios.create({
  baseURL: window.__env.back_end.casterapi_url,
});

casterapiax.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    /**inser what to do in case of error */
    return Promise.reject(ErrorInterceptor.helper(error));
  }
);
export const casterapi = casterapiax;
// export const casterapiMetrics = casterapiax; the duplicate is necessary in case a new call withit's own default timeout is requested.

// for yc-caster-api (via Traefik gateway)
const yccasterapiax = axios.create({
  baseURL: window.__env.back_end.yc_caster_api_url,
});

yccasterapiax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
yccasterapiax.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => Promise.reject(ErrorInterceptor.helper(error))
);
export const yccasterapi = yccasterapiax;

// for task-manager (via Traefik gateway)
const taskmanagerax = axios.create({
  baseURL: window.__env.back_end.task_manager_url,
});

taskmanagerax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
taskmanagerax.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => Promise.reject(ErrorInterceptor.helper(error))
);
export const taskmanager = taskmanagerax;

// for rtk-analyzer
const rtkanalyzerax = axios.create({
  baseURL: window.__env.back_end.rtk_analyzer_url,
});

rtkanalyzerax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
rtkanalyzerax.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => Promise.reject(ErrorInterceptor.helper(error))
);
export const rtkanalyzer = rtkanalyzerax;

//used for log call withno token
export const traefikx = axios.create({
  baseURL: window.__env.back_end.traefik_url,
});

traefikx.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    /* push alert with login failed and why */
    return Promise.reject(ErrorInterceptor.helper(error));
  }
);

export const traefik =traefikx

// for user-manager — Basic Auth, routed via Traefik (/ambr/)
const usermanagerax = axios.create({
  baseURL: window.__env.back_end.traefik_url,
});

usermanagerax.interceptors.request.use((config) => {
  if (store.getUser() && store.getToken()) {
    config.headers.Authorization = store.getToken();
  }
  return config;
});
usermanagerax.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    const errorMessage = ErrorInterceptor.helper(error);
    ErrorInterceptor.serverError(errorMessage);
    return Promise.reject(errorMessage);
  }
);
export const usermanager = usermanagerax;